import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ColumnMode } from '@swimlane/ngx-datatable';
import { CreateVaultCompanyMovementComponent } from 'app/dialogs/create-vault-company-movement/create-vault-company-movement.component';
import { AuthService } from 'app/services/auth.service';
import { PersonService } from 'app/services/models/person.service';
import { VaultService } from 'app/services/models/vault.service';
import { BlockUI, NgBlockUI } from 'ng-block-ui';

@Component({
  selector: 'app-company-detail-vault-movements',
  templateUrl: './company-detail-vault-movements.component.html',
  styleUrls: ['./company-detail-vault-movements.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CompanyDetailVaultMovementsComponent implements OnInit {
  constructor(
    private vaultService: VaultService,
    private activatedRouter: ActivatedRoute,
    private modalService: NgbModal,
    public authService: AuthService) { }
  @BlockUI('section-block') blockUI: NgBlockUI;
  companyId = null;
  rows: any;
  public pageBasic = 1;
  public selectedSize = 5;
  public basicSelectedOption: number = 5;
  totalCount: Number = 0;
  public ColumnMode = ColumnMode;

  async ngOnInit() {
    this.activatedRouter.params.subscribe(params => {
      this.companyId = params['id'];
    })
    console.log(this.companyId);
    this.vaultService.event$.subscribe(async result => {
      await this.getAllCompanyVaultMovements(this.pageBasic - 1, this.selectedSize, this.companyId);
    });
    await this.getAllCompanyVaultMovements(this.pageBasic - 1, this.selectedSize, this.companyId);
  }

  async getAllCompanyVaultMovements(page, size, companyId) {
    this.blockUI.start("Firma hesap hareketleri...")
    try {
      const data = await this.vaultService.getAllCompanyByIdVaultMovement(page, size, companyId);
      this.rows = data.companyVaultMovements;
      console.log(data);
      this.totalCount = data.totalCount;
    } catch (error) {
    }
    this.blockUI.stop()
  }

  async onPageChange(pageNumber: number) {
    await this.getAllCompanyVaultMovements(this.pageBasic - 1, this.selectedSize, this.companyId);
  }

  async onOptionChange() {
    this.selectedSize = Number(this.basicSelectedOption)
    await this.getAllCompanyVaultMovements(this.pageBasic - 1, this.selectedSize, this.companyId);
  }

  createCompanyVaultDialog() {
    const modal = this.modalService.open(CreateVaultCompanyMovementComponent);
    modal.componentInstance.data = {
      companyId: this.companyId,
      transactionId: null,
      price: null
      //  @Input() data : {companyId:number,transactionId:number,price:number};
    }
  }
}
